import api from "../services/api";

export const createBankDetails = async (bank_name, branch_name, account_number, swift_code, branch_code) => {
  try {
    const response = await api.post(
      "/transaction-management/payments/bank-details/create",
      {
        bank_name,
        branch_name,
        account_number,
        swift_code,
        branch_code
      }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: response.data?.error || "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.response?.data?.detail || error.message || "Failed to create bank details" };
  }
};


export const fetchBankDetails = async () => {
  try {
    const response = await api.get(
      "/transaction-management/payments/bank-details/all"
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to fetch bank details" };
  }
};

export const updateBankDetails = async (bankId, updates) => {
  try {
    const response = await api.put(
      `/transaction-management/payments/bank-details/update/${bankId}`,
      updates
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to update bank details" };
  }
};


export const deleteBankDetails = async (bankId) => {
  try {
    const response = await api.delete(
      `/transaction-management/payments/bank-details/delete/${bankId}`
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, message: "Bank details deleted successfully" };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to delete bank details" };
  }
};
